import React from 'react'
import { NavigationStackScreenComponent } from 'react-navigation-stack'
import { ConstructionsTabs } from './ConstructionsTabs'
import { CustomHeader } from '../../components/CustomHeader'
import { Coordinator } from '../../navigation/coordinator/coordinator'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'

export const Constructions: NavigationStackScreenComponent = () => {
  return <ConstructionsTabs />
}

Constructions.navigationOptions = CustomHeader(formatMessage(messages.constructions_headerTitle), true, () =>
  Coordinator.goBack()
)
